import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import BlockKitLoader from './components/BlockKitLoader';

// BlockKit components
const BlockKitEditorDemo = lazy(() => import('./routes/BlockKitEditorDemo'));
const BlockKitSample = lazy(() => import('./routes/Sample'));

/**
 * Routes for the Elements app
 * These routes are designed to be loaded in an iframe
 */
function BlockKitRoutes() {
  return (
    <Routes>
       <Route path="editor" element={
          <Suspense fallback={<BlockKitLoader />}>
            <BlockKitEditorDemo />
          </Suspense>
        } />
        <Route path="sample" element={
          <Suspense fallback={<BlockKitLoader />}>
            <BlockKitSample />
          </Suspense>
        } />
    </Routes>
  );
}

export default BlockKitRoutes;
